// breakpoint values
// any array length works with styled-system
const breakpoints = [
  '40em', '52em', '64em', '76em', '88em',
]

const maxWidths = {
  tiny: '30rem',
  small: '40rem',
  medium: '50rem',
  large: '60rem',
}

const colors = {
  white: 'rgba(250, 250, 250, 1)',
  primary: [
    '#f16666',
    '#d54848',
    '#b83232',
  ],
  secondary: [
    '#8579e6',
    '#7759B8',
    '#674aa6',
  ],
  positive: '#4eab5f',
  darken: [
    'rgba(0, 0, 0, 0.05)',
    'rgba(0, 0, 0, 0.1)',
    'rgba(0, 0, 0, 0.2)',
    'rgba(0, 0, 0, 0.4)',
    'rgba(0, 0, 0, 0.6)',
    'rgba(0, 0, 0, 0.8)',
  ],
  gray: [
    'hsl(0, 0%, 25%)',
    'hsl(0, 0%, 35%)',
    'hsl(0, 0%, 45%)',
    'hsl(0, 0%, 60%)',
    'hsl(0, 0%, 75%)',
    'hsl(0, 0%, 90%)',
    'hsl(0, 0%, 95%)',
  ],
  brand: {
    twitter: '#07c',
    facebook: '#058',
  },
}

// space is used for margin and padding scales
// it's recommended to use powers of two to ensure alignment
// when used in nested elements
// numbers are converted to px
const space = [
  0, 4, 8, 16, 32, 64, 128, 256, 512,
]

// typographic scale
const fontSizes = [
  12, 14, 16, 18, 20, 24, 32, 48, 64, 96, 128,
]

// for any scale, either array or objects will work
const lineHeights = [
  1, 1.125, 1.25, 1.5,
]

const fontWeights = {
  normal: 400,
  bold: 700,
}

const letterSpacings = {
  normal: 'normal',
  caps: '0.25em',
}

// border-radius
const radii = [
  0, 2, 4, 8,
]

const borders = [
  0, '1px solid', '2px solid', '4px solid', '6px solid',
]

export default {
  breakpoints,
  colors,
  space,
  fontSizes,
  lineHeights,
  fontWeights,
  letterSpacings,
  radii,
  borders,
  maxWidths,
}



// WEBPACK FOOTER //
// /opt/build/repo/src/theme.js